import { filterParams as base } from './artwork';
import { createFilterTransfer, stringFilter } from './common';

const columnsTransfer = {
  artistId: [ 'artist' ],
  isSignature: [ 'signature', 'isSignature' ],
  artistIdId: [ 'artist' ],
};

export const filterTransfer = createFilterTransfer(base.filters, columnsTransfer);

export const filterParams = {
  ...base,
  filters: {
    ...base.filters,
    title: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    artistId: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    category: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    medium: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    lastSaleNumber: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    lastLotNumber: stringFilter('artwork', null, 'AND(customer_arts__is_considerations:0)'),
    auctionHouseLast: stringFilter('artwork', 'auction_lots__auction_id', 'AND(customer_arts__is_considerations:0)'),
    artistIdWfAcceptance: stringFilter('artwork', 'artist_id__wf_acceptance', 'AND(customer_arts__is_considerations:0)'),
    usernameLastUpdate: stringFilter('artwork'),
  },
  columnsTransfer,
  filterTransfer,
};

export default filterParams.filters;
